module.exports = __webpack_public_path__ + "img/地热国1_1.f77e5bec.png";